<template>
    <v-bottom-navigation
        app
        fixed
        input-value
        class="footer-menu"
        v-model="active"
    >
        <div class="footer-menu__container">
            <div class="footer-block">
                <v-btn
                    v-for="(route, key) in routes"
                    :key="key"
                    :to="route.to"
                    class="px-0"
                    active-class="footer-btn-active"
                >
                    <span>{{ route.name }}</span>
                    <div v-html="route.svg" />
                </v-btn>
            </div>
        </div>
        <ModalConnect v-model="modalErrorConnection"></ModalConnect>
    </v-bottom-navigation>
</template>

<script>
import ModalConnect from "@/components/modals/ModalConnect";
import Centrifuge from "centrifuge";
import {eventBus} from "@/main";

export default {
    name: "FooterMenu",
    components: {
        ModalConnect,
    },
    data() {
        return {
            show: false,
            active: 0,
            routes: [
                {
                    name: 'Устройства',
                    to: '/devices',
                    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99 6.00955V6H10.979C11.41 6 11.76 6.33439 11.76 6.74427C11.76 7.16561 11.41 7.5 10.979 7.5H7.99C7.559 7.5 7.21 7.16561 7.21 6.75478C7.21 6.34395 7.559 6.00955 7.99 6.00955ZM13.1706 12.5H7.74936C7.45133 12.5 7.21 12.1637 7.21 11.7505C7.21 11.3373 7.45133 11 7.74936 11H13.1706C13.468 11 13.71 11.3373 13.71 11.7505C13.71 12.1637 13.468 12.5 13.1706 12.5ZM8.08 17.4939H15.92C16.319 17.4559 16.62 17.1323 16.62 16.7536C16.62 16.3645 16.319 16.0418 15.92 16.0038H8.08C7.78 15.9753 7.49 16.1082 7.33 16.355C7.17 16.5922 7.17 16.9055 7.33 17.1522C7.49 17.3895 7.78 17.5319 8.08 17.4939Z" fill="currentColor"/>
                        <path d="M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2" stroke="currentColor" stroke-width="1.5"/>
                    </svg>`,
                },
                {
                    name: 'Сценарии',
                    to: '/scenarios',
                    svg: `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 6V11.7143C12.5 12.0098 12.5282 12.2005 12.7788 12.3571L16.2074 14.5M2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
                },
                {
                    name: 'Профиль',
                    to: '/profile',
                    svg: `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 2C10.0949 2 8.14516 4.03766 8.14516 6.55123C8.14516 9.06481 10.0949 11.1025 12.5 11.1025C14.9051 11.1025 16.8548 9.06481 16.8548 6.55123C16.8548 4.03766 14.9051 2 12.5 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.85484 13.5298C5.44973 13.5298 3.5 15.5674 3.5 18.081V19.5232C3.5 20.4374 4.13393 21.2168 4.99722 21.3641C9.96618 22.212 15.0338 22.212 20.0028 21.3641C20.8661 21.2168 21.5 20.4374 21.5 19.5232V18.081C21.5 15.5674 19.5503 13.5298 17.1452 13.5298H16.7493C16.5351 13.5298 16.3222 13.5652 16.1185 13.6347L15.1134 13.9777C13.4152 14.5572 11.5848 14.5572 9.88662 13.9777L8.8815 13.6347C8.67784 13.5652 8.46494 13.5298 8.25069 13.5298H7.85484Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>`,
                },
            ],
            reconnect: false,
            modalErrorConnection: false,
        };
    },
    mounted() {
        if (localStorage.getItem('theme')) {
            document.documentElement.setAttribute('data-theme', localStorage.getItem('theme'));
        }
        if (this.$route.query.master_key) {
            localStorage.removeItem("RobohomeDataAccessToken");
            this.$router.push({name: "master", query: this.$route.query});
        } else if (this.$store.state.accessToken) {
            this.openWebSocket();
        } else if (!this.$store.state.accessToken) {
            this.$router.push({ name: "empty" });
        }
    },
    computed: {
        notErrorPage() {
            return this.$store.state.accessToken && this.$route && this.$route.name != "empty" && this.$route.name != "final";
        },
    },
    watch: {
        "$store.state.home": function() {
            this.openWebSocket();
        },
    },
    methods: {
        openWebSocket() {
            const centrifuge = new Centrifuge(`${process.env.VUE_APP_WS_API_URL}`, {
                retry: 1000,
                maxRetry: 2000,
            });
            const user_access_token = this.$store.state.accessToken;
            if (this.$store.state.home) {
                const room_pk = this.$store.state.home.uid;
                centrifuge.setConnectData({
                    'user_access_token': user_access_token,
                    'home_pk': room_pk,
                });
                let is_subscribe = false;

                centrifuge.on('connect', (ctx) => {
                    console.log("connected", ctx);
                    if (this.reconnect) {
                        this.reconnect = false;
                        eventBus.$emit("reconnect");
                    }
                    if (this.notErrorPage) {
                        this.modalErrorConnection = false;
                    }
                    let room_id = ctx.data.home_token;

                    if (!is_subscribe) {
                        centrifuge.subscribe("home_update:home_" + room_id, (ctx) => {
                            if (ctx.data.update_type == "scenario") {
                                eventBus.$emit("scenario", {
                                    id: ctx.data.scenario.uid,
                                    enabled: ctx.data.scenario.enabled,
                                });
                            } else if (ctx.data.update_type == "device") {
                                eventBus.$emit("device", {
                                    device: ctx.data.device
                                });
                            } else if (ctx.data.update_type == "scenario_group") {
                                eventBus.$emit("scenarioGroup", {
                                    group: ctx.data.group
                                });
                            }
                        });
                        is_subscribe = true;
                    }
                });

                centrifuge.on('disconnect', (ctx) => {
                    console.log("disconnected", ctx);
                    this.reconnect = true;
                    if (this.$route && this.$route.name != "final" && this.$route.name != "empty") {
                        if (this.notErrorPage) {
                            this.modalErrorConnection = true;
                        }
                    }
                });
                centrifuge.connect();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.footer-menu.v-bottom-navigation {
    display: flex;
    box-shadow: none;
    height: 56px;
    min-height: 56px;
    max-height: 56px;
    overflow: hidden;
    min-width: 100%;

    .footer-menu__container {
        min-width: 100%;
        display: flex;
        background-color: var(--dark-black-2);
        height: 100%;
        position: relative;
        justify-content: center;
    }

    .footer-block {
        background-color: var(--dark-black-2);
        max-width: 900px;
        width: 100%;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        box-shadow: none;
        height: 56px;
        min-height: 56px;
        max-height: 56px;
        overflow: hidden;
    }

    .v-btn {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        color: var(--dark-grey-2) !important;

        &.v-btn--active {
            background: none;

            &:before {
                content: none;
            }
        }

        &:not(.v-btn--active) {
            color: var(--dark-grey-2) !important;
        }

        &.footer-btn-active {
            color: var(--dark-orange) !important;

            svg {
                color: var(--dark-orange) !important;
            }
        }

        span {
            margin-top: 4px;
        }
    }
}
</style>